import BigNumber from 'bignumber.js'
import { ethers } from 'ethers'
import { formatUnits } from 'ethers/lib/utils'
import { BIG_TEN } from 'config/constants/bigNumber'

/**
 * Take a formatted amount, e.g. 15 BNB and convert it to full decimal value, e.g. 15000000000000000
 */
export const getDecimalAmount = (amount: BigNumber | number | string, decimals = 18): BigNumber =>
  new BigNumber(amount || 0).times(BIG_TEN.pow(decimals))

export const getBalanceAmount = (amount: BigNumber | number | string, decimals = 18): BigNumber =>
  new BigNumber(amount || 0).dividedBy(BIG_TEN.pow(decimals))

/**
 * This function is not really necessary but is used throughout the site.
 */
export const getBalanceNumber = (balance: BigNumber | number | string, decimals = 18) =>
  getBalanceAmount(balance, decimals).toNumber()

// eslint-disable-next-line default-param-last
export const getFullDisplayBalance = (balance: BigNumber | number | string, decimals = 18, displayDecimals?: number) =>
  getBalanceAmount(balance, decimals).toFixed(displayDecimals)

/**
 * Method to format the display of wei given an ethers.BigNumber object
 * Note: does NOT round
 */
export const formatBigNumber = (number: ethers.BigNumber, displayDecimals = 18, decimals = 18) => {
  const remainder = number.mod(ethers.BigNumber.from(10).pow(decimals - displayDecimals))
  return formatUnits(number.sub(remainder), decimals)
}
